import ImageInsert from "./ImageInsert";
import ButtonInsert from "./ButtonInsert";

/**
 * Everything the "Insert" menu offers. Adding a new kind of content means:
 *   1. a component that renders its settings/preview and calls `onInsert(html)`,
 *   2. an email-safe generator in emailHtml.js,
 *   3. one entry here.
 * Components receive `{ onInsert, onCancel }` and nothing else — they must not know about
 * the composer's body or cursor; the page owns the splice.
 */
const INSERT_TYPES = [
  {
    id: "image",
    label: "Image / GIF",
    description: "Upload or pick from the media library, then size, align and link it.",
    Component: ImageInsert,
  },
  {
    id: "button",
    label: "Button",
    description: "A call-to-action button with a link.",
    Component: ButtonInsert,
  },
];

export default INSERT_TYPES;
